<div class="left-menu" [class.open]="isVisible()">
    <div class="menu-nav">
        <ng-content></ng-content>
        <a class="left-menu-item py-1 col-12" (click)="signOut.emit()">
            <fa-icon class="mx-2 col-1 d-inline-block" [icon]="['fas', 'right-from-bracket']"></fa-icon>
            <span class="col-10 d-inline-block">Sign out</span>
        </a>
    </div>
    <div class="menu-bottom">
        <div class="theme-toggle-wrapper">
            <button
                class="theme-toggle"
                [class.dark]="theme() === 'dark'"
                (click)="toggleTheme()"
                [attr.aria-label]="theme() === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
            >
                <span class="theme-toggle-track">
                    <span class="theme-toggle-thumb"></span>
                    <span class="theme-toggle-option sun">
                        <fa-icon [icon]="['fas', 'sun']"></fa-icon>
                    </span>
                    <span class="theme-toggle-option moon">
                        <fa-icon [icon]="['fas', 'moon']"></fa-icon>
                    </span>
                </span>
            </button>
        </div>
    </div>
</div>
@if (isVisible() && !alwaysVisible()) {
    <div class="left-menu-overlay" (click)="toggleVisibility()"></div>
}
